export const GET_ALL_VIDEO_REQUEST = "GET_ALL_VIDEO_REQUEST";
export const GET_ALL_VIDEO_SUCCESS = "GET_ALL_VIDEO_SUCCESS";
export const GET_ALL_VIDEO_FAILURE = "GET_ALL_VIDEO_FAILURE";
